import React from 'react';
import { observer } from 'mobx-react-lite';
import Select from 'react-select';
import { Grid } from '@material-ui/core';
import { NumberInput } from '../../store/inputs/NumberInput';

const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderColor: state.isFocused ? '#1a73e8' : '#e0e0e0',
    borderWidth: '1px',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(26,115,232,0.12)' : 'none',
    borderRadius: '8px',
    minHeight: '38px',
    fontSize: '13px',
    '&:hover': { borderColor: '#bdbdbd' },
  }),
  placeholder: (base: any) => ({ ...base, color: '#9e9e9e', fontSize: '13px' }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: '13px',
    padding: '8px 12px',
    backgroundColor: state.isSelected ? '#e8f0fe' : state.isFocused ? '#f5f5f5' : '#fff',
    color: '#424242',
    '&:active': { backgroundColor: '#e8f0fe' },
  }),
  menu: (base: any) => ({
    ...base,
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    zIndex: 10,
  }),
  singleValue: (base: any) => ({ ...base, fontSize: '13px', color: '#424242' }),
};

const CDropDownInput = observer(({ item }: { item: NumberInput }) => {
  const { label, value, onChange, disabled, isKey, isEdit, dropDownValues } = item;

  const isLocked = disabled || (isKey && isEdit);

  const options = Object.entries(dropDownValues || {}).map(([key, val]) => ({
    label: key,
    value: val,
  }));

  const selectedOption = options.find((o) => o.value === value) || null;

  return (
    <Grid container spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <div
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '10px',
            padding: '12px 16px',
            margin: '8px 0',
            background: isLocked ? '#fafafa' : '#fff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <i
              className={isKey ? 'bx bx-key' : 'bx bx-chevron-down-circle'}
              style={{ fontSize: '14px', color: '#757575', marginRight: '6px' }}
            />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
              {label}
            </span>
          </div>
          <Select
            placeholder="Select..."
            isDisabled={isLocked}
            value={selectedOption}
            onChange={(v) =>
              onChange((v as { label: string; value: number }).value)
            }
            options={options}
            styles={selectStyles}
          />
        </div>
      </Grid>
    </Grid>
  );
});

export default CDropDownInput;
